import React, { Component } from "react";
import { Scrollbars } from "react-custom-scrollbars";
import _ from "lodash";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import settings from "./settings.js";
import ClientBadge from "./components/ClientBadge.js";
import { Link } from "react-router-dom";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      data: [],
      searchString: "",
      modal: false,
      selectedContract: null,
      cats: [],
      filterClientID: 0,
      filterCategory: "",
    };
  }

  componentDidMount() {
    // Check if category filter was passed via route state
    const categoryFromState = this.props.location?.state?.filterCategory;

    // Show loading overlay during initial load
    this.props.loading(true);

    // Always load categories first
    this.loadCategories().then(() => {
      // Then set the filter category if provided
      if (categoryFromState) {
        this.setState({ filterCategory: categoryFromState }, () => {
          this.loadContracts();
        });
      } else {
        this.loadContracts();
      }
    });

    this.props.addBreadcrumb([
      {
        name: "Contacten en afspraken",
        url: "/contacten-afspraken",
        reset: true,
      },
    ]);
  }

  componentWillUnmount() {
    // Clear timeout to prevent memory leaks
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  }

  loadContracts = () => {
    this.setState({ isLoading: true });
    // Only show loading overlay if not already showing (for search/filter changes)
    if (!this.props.isLoading) {
      this.props.loading(true);
    }
    const params = {
      ...(this.state.filterClientID &&
        this.state.filterClientID !== "0" && {
          client: this.state.filterClientID,
        }),
      ...(this.state.filterCategory &&
        this.state.filterCategory !== "" && {
          category: this.state.filterCategory,
        }),
    };
    fetch(
      settings.server_url +
        "get_contracts/" +
        window.sessionStorage.getItem("sid"),
      {
        method: "POST",
        body: JSON.stringify({
          search: this.state.searchString,
          ...params,
        }),
      }
    )
      .then((res) => res.json())
      .then((response) => {
        this.setState({ data: response.data, isLoading: false });
        this.props.loading(false);
      })
      .catch((error) => {
        console.error("Error:", error);
        this.props.loading(false);
      });
  };

  loadCategories = () => {
    return fetch(
      settings.server_url +
        "get_contracts_categories/" +
        window.sessionStorage.getItem("sid"),
      {
        method: "POST",
      }
    )
      .then((res) => res.json())
      .then((response) => {
        this.setState({ cats: response.data.data });
      })
      .catch((error) => console.error("Error:", error));
  };

  handleSearchChange = (e) => {
    const value = e.target.value;
    this.setState({ searchString: value });

    // Clear existing timeout
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    // Set new timeout for debounced search
    this.searchTimeout = setTimeout(() => {
      this.loadContracts();
    }, 500); // 500ms delay
  };

  handleClientChange = (e) => {
    this.setState({ filterClientID: e.target.value }, () => {
      this.loadContracts();
    });
  };
  handleCategoryChange = (e) => {
    this.setState({ filterCategory: e.target.value }, () => {
      this.loadContracts();
    });
  };

  toggle = (contract = null) => {
    this.setState((prevState) => ({
      modal: !prevState.modal,
      selectedContract: contract,
    }));
  };

  handleContractClick = (contract) => {
    this.toggle(contract);
  };

  render() {
    const { data } = this.state;
    return (
      <Scrollbars
        renderView={this.renderView}
        renderThumbHorizontal={this.renderThumb}
        renderThumbVertical={this.renderThumb}
        onUpdate={this.handleUpdate}
        className="row ml-0 content-bc">
        <div className="col p-md-4 px-0 maxw1200">
          <div className="newsContainer">
            <div className="col">
              <div className="newsHeader">
                <div className="newsHeaderTitle">Contacten en afspraken</div>
                <div className="newsHeaderSearch">
                  <div className="newsHeaderSearchSelect">
                    <div className="form-label">Toon</div>
                    <select
                      className="form-control"
                      onChange={this.handleClientChange}
                      value={this.state.filterClientID}>
                      <option value="0">Alle afdelingen</option>
                      <option value="10">Van der Valk Koel & Vries</option>
                      <option value="11">Van der Valk Centraal Magazijn</option>
                      <option value="29">Van der Valk Apparaten</option>
                      <option value="54">Van der Valk Dagvers</option>
                      <option value="61">Van der Valk Vis</option>
                      <option value="69">Van der Valk Versmarkt</option>
                      <option value="120">Valk en Vlees</option>
                    </select>
                  </div>
                  <div className="newsHeaderSearchSelect">
                    <select
                      className="form-control"
                      onChange={this.handleCategoryChange}
                      value={this.state.filterCategory}>
                      <option value="">Alle categorieën</option>
                      {this.state.cats.map((cat, index) => (
                        <option key={index} value={cat.vc_category}>
                          {cat.vc_category}
                        </option>
                      ))}
                    </select>
                  </div>
                  <input
                    type="text"
                    placeholder="Zoeken"
                    className="form-control"
                    value={this.state.searchString}
                    onChange={this.handleSearchChange}
                  />
                </div>
              </div>
            </div>
            <div className="">
              {this.state.isLoading ? (
                <div>Laden...</div>
              ) : data && data.length > 0 ? (
                data.map((contract, index) => {
                  // Datum formatteren
                  let contractDate = contract.contractDate
                    ? new Date(contract.contractDate)
                    : null;
                  let formattedDate = contractDate
                    ? `${contractDate.getDate().toString().padStart(2, "0")}-${(
                        contractDate.getMonth() + 1
                      )
                        .toString()
                        .padStart(2, "0")}-${contractDate.getFullYear()}`
                    : "";

                  return (
                    <div
                      className="news"
                      key={contract.contractId || index}
                      onClick={() => this.handleContractClick(contract)}>
                      <div className="newsContract">
                        <div className="newsTitle">
                          <div
                            style={{
                              alignItems: "center",
                              display: "inline-flex",
                              height: "100%",
                              alignSelf: "center",
                            }}>
                            <ClientBadge clientId={contract.contractClientId} />
                          </div>
                          {contract.contractName || "Naam onbekend"}
                        </div>
                        {contract.contractText && (
                          <div
                            className="text-left"
                            style={{ padding: "10px 0 0 0" }}>
                            {(contract.contractText || "")
                              .split("\n")
                              .map((line, index) => (
                                <div key={index}>{line}</div>
                              ))}
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })
              ) : (
                <div>Geen contacten en afspraken gevonden</div>
              )}
            </div>
          </div>
        </div>
      </Scrollbars>
    );
  }
}

export default Home;
